var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFontsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 22,
    viewBox: "0 0 38 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45 2.015.265 18.24c-.147.324-.265.648-.265.972 0 1.178.913 2.12 2.09 2.12.943 0 1.709-.53 2.092-1.413l1.443-3.386h9.07l1.383 3.238c.412.943 1.12 1.561 2.18 1.561 1.207 0 2.15-.971 2.15-2.179 0-.294-.09-.589-.237-.913L12.986 2.015c-.5-1.12-1.384-1.796-2.62-1.796H10.1c-1.238 0-2.15.677-2.651 1.796zm2.71 3.71 2.856 6.803H7.303l2.856-6.803zM22.555 16.562v.059c0 3.121 2.445 4.829 5.419 4.829 2.179 0 3.68-.795 4.77-2.002v.029c0 .942.854 1.855 2.15 1.855 1.207 0 2.18-.942 2.18-2.15v-7.185c0-2.12-.53-3.857-1.709-5.035-1.119-1.12-2.886-1.767-5.33-1.767-2.09 0-3.622.295-5.035.825a1.856 1.856 0 0 0-1.208 1.737c0 1.03.825 1.826 1.855 1.826.207 0 .384-.03.648-.118.854-.265 1.856-.442 3.092-.442 2.238 0 3.387 1.03 3.387 2.886v.265a11.212 11.212 0 0 0-3.858-.648c-3.74 0-6.36 1.59-6.36 5.036zm10.278-1.767v.795c0 1.62-1.414 2.768-3.505 2.768-1.442 0-2.444-.707-2.444-1.914v-.059c0-1.413 1.178-2.18 3.092-2.18 1.09 0 2.091.237 2.857.59z",
    fill: "#6238F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontsIcon);
export default __webpack_public_path__ + "static/media/fonts-icon.ca9d66e374de40825505cd99de50dd6b.svg";
export { ForwardRef as ReactComponent };